module.exports = __webpack_public_path__ + "img/zsgc.ae072aec.png";